<template>
  <div class="articlepage-container">
    <home-nav :redirect="redirect" >
      <div class="articlepage-banner" slot="topbanner">
        <div class="article-header">
          {{title}}
        </div>
         <section class="relevant-line">
          <p class="read">
            <img src="@/assets/images/m_faq_articles_read@3x.png" alt="">
            <span>{{post_views_count | readparse}}</span>
          </p>
          <p class="time">
            <img src="@/assets/images/m_faq_articles_time@3x.png" alt="">
            <span>{{date | dateparse}}</span>
          </p>
        </section>
      </div>
    </home-nav>
    <div v-html="content" class="article-content">
    </div>
    <download-item :downloadinfo="m_guoshixiong_article"></download-item>
    <android-download ></android-download>
    <share-item></share-item>
    <copyright-footer></copyright-footer>
    <Footer_></Footer_>
  </div>
  
</template>

<script>
import AndroidDownload from '@/components/modules/AndroidDownload';
import ShareItem from '@/components/modules/ShareItem';
import Footer_ from '@/components/Footer';

export default {

  data(){
    return{
      content:"",
      redirect:true,
      title:"",
      post_views_count:"",
      date:"",
      m_guoshixiong_article: {
        download_channel: "m.gsx.article",
        download_channel_name: "文章内页-立即下载",
      },
      id:0,
    }
  },
  methods:{
    getDetail(){
      var vm = this;
      var info = {
        id : vm.id
      }
      this.$store.dispatch("getDetail",info).then((res)=>{
        var data = res.data;
        var post = data.post;
        vm.content = post.content;
        vm.title = post.title;
        if(vm.title){
          document.title = vm.title;
        }
        
        vm.post_views_count = post.custom_fields.post_views_count[0];
        vm.date = post.date;
      })
    },
    setPostViews(){
      this.$store.dispatch("setArticleViews",this.id).then((res)=>{
       //加一
      })
    }
  },
  
  mounted(){
      this.getDetail();
      this.setPostViews();
  },
  created(){
    this.id = this.$route.query.id

  },
  filters:{
    dateparse(val){
      var dateArr = val.split(" ")
      return dateArr[0]
    },
    readparse(val){
      if(val>1000000){
        return "10万+";
      }else{
        return val;
      }
    }
  },
  components:{
    AndroidDownload,
    ShareItem,
    Footer_
  }
}
</script>

<style lang="scss" >

@import '../assets/css/base.scss';
.articlepage-container{
  min-height: 100vh;
  background: #ffffff;
  .articlepage-banner{
    width:px2vw(355px);
    background:rgba(255,255,255,0.97);
    box-shadow:0px 4px 5px -2px rgba(0,0,0,0.2);
    border-radius:pxtorem(6px);
    margin:0 auto;
    padding:pxtorem(10px) pxtorem(16px);
    box-sizing: border-box;
    .relevant-line {
        color: rgba(191, 191, 191, 1);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-top: pxtorem(10px);
        .read {
            display: flex;
            align-items: center;
            max-width: pxtorem(100px);
            overflow: hidden;
            img {
                width: pxtorem(26px);
            }
        }
        .time {
            display: flex;
            align-items: center;
            margin-left: pxtorem(4px);
            img {
                width: pxtorem(22px);
            }
        }
    }

  }
  .article-header{
    font-size:pxtorem(18px);
    line-height: pxtorem(26px);
    height: pxtorem(52px);
  }
  .article-content{
      padding:0 pxtorem(20px) pxtorem(20px);
      box-sizing: border-box;
      p{
        padding-top:pxtorem(10px);
        font-size: pxtorem(14px);
        line-height: pxtorem(20px);
      }
      img{
        max-width: 100%;
        display: block;
        margin: pxtorem(16px) auto;
      
      }

    }

}

</style>



// WEBPACK FOOTER //
// src/components/ArticlePage.vue